// extracted by mini-css-extract-plugin
export default {"component":"MAKeySecurities_component__b4VAB","desc":"MAKeySecurities_desc__apcSs","table":"MAKeySecurities_table__pmSwL","abbr":"MAKeySecurities_abbr__vhU-W"};